
import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import paginacion from "./lista-listado-paginacion.vue";
import { ControladorSeccion } from "./controlador";
import { DataTableHeader } from "vuetify";
import { Pedido } from "@/__env/lib/Ventas/Pedidos";
import { Envio } from "@/__env/lib/Ventas/Envios";
import { Utiles } from "@/__env/pluggins/event-bus";
import router from "@/__env/router.index";
import * as Pedidos from "@lib/Ventas/Pedidos";

@Component({
  name: "Componente",
  props: {},
  components: {
    paginacion
  }
})
export default class Componente extends Vue {
  @Prop()
  public Controlador: ControladorSeccion;
  public get Buscador() {
    return this.Controlador.Buscador;
  }
  public get Estado() {
    return this.Controlador.Buscador.Estado;
  }
  public get Items() {
    return this.Controlador.Buscador.Items;
  }
  public get Seleccionados() {
    return this.Controlador.Seleccionados;
  }
  public get Modo() {
    return this.Controlador.Vista.Modo;
  }

  async Llamado(item: Pedido, tr: string) {
    await item.ModificarLlamado(tr);
  }

  protected Eventos: Function[] = [];
  beforeDestroy() {
    this.Eventos.forEach(x => x());
  }
  mounted() {}

  public get Headers(): Array<DataTableHeader> {
    if (this.Modo == "items") {
      return [
        { text: "", align: "center", value: "Imagen", width: "65px" },
        { text: "Codigo", align: "start", value: "Col1" },
        { text: "Cliente", align: "start", value: "Col2", width: "190px" },
        { text: "Estado", align: "start", value: "Col3" },
        { text: "Importe", align: "end", value: "Col5" },
        { text: "Items", align: "center", value: "Items1" },
        { text: "1er Artículo", align: "center", value: "Items2" },
        { text: "", align: "end", value: "Col8", width: "215px" }
      ];
    }

    if (this.Modo == "envio") {
      return [
        { text: "", align: "center", value: "Imagen", width: "65px" },
        { text: "Codigo", align: "start", value: "Col1" },
        { text: "Cliente", align: "start", value: "Col2", width: "190px" },
        { text: "Estado", align: "start", value: "Col3" },
        { text: "Logística", align: "start", value: "logistica" },
        { text: "Dirección", align: "start", value: "Envio1" },
        { text: "Tipo", align: "end", value: "Col6" },
        { text: "", align: "end", value: "Col8", width: "215px" }
      ];
    }

    return [
      { text: "", align: "center", value: "Imagen", width: "65px" },
      { text: "Codigo", align: "start", value: "Col1" },
      { text: "Cliente", align: "start", value: "Col2", width: "190px" },
      { text: "Estado", align: "start", value: "Col3" },
      { text: "Telefono/Email", align: "start", value: "Col4" },
      { text: "Importe", align: "end", value: "Col5" },
      { text: "Tipo", align: "end", value: "Col6" },
      { text: "Fecha", align: "end", value: "Col7" },
      { text: "", align: "end", value: "Col8", width: "215px" }
    ];
  }

  public CargandoMenu: boolean = false;
  public Opciones = [
    { Tipo: "titulo", Titulo: "Archivos" },
    {
      Tipo: "opcion",
      Titulo: "Nota de venta",
      Accion: async (item: Pedido) => {
        this.CargandoMenu = true;
        Utiles.GenerandoArchivo(true);
        let pdf = await Pedido.URLNotaDeVenta([item]);
        if (pdf) {
          window.open(pdf);
        } else {
          Utiles.Notificaciones.Error(`Error al generar archivo`);
        }
        Utiles.GenerandoArchivo(false);
        this.CargandoMenu = false;
      }
    },

    {
      Tipo: "opcion",
      Titulo: "Presupuesto",
      Accion: async (item: Pedido) => {
        this.CargandoMenu = true;
        Utiles.GenerandoArchivo(true);
        let pdf = await Pedido.URLPresupuesto([item]);
        if (pdf) {
          window.open(pdf);
        } else {
          Utiles.Notificaciones.Error(`Error al generar archivo`);
        }
        Utiles.GenerandoArchivo(false);
        this.CargandoMenu = false;
      }
    },

    {
      Tipo: "opcion",
      Titulo: "Formulario MercadoPago",
      Accion: async (item: Pedido) => {
        this.CargandoMenu = true;
        Utiles.GenerandoArchivo(true);
        let pdf = await Pedido.URLNotaMercadoPago([item]);
        if (pdf) {
          window.open(pdf);
        } else {
          Utiles.Notificaciones.Error(`Error al generar archivo`);
        }
        Utiles.GenerandoArchivo(false);
        this.CargandoMenu = false;
      }
    },
    {
      Tipo: "opcion",
      Titulo: "Etiqueta envío",
      Accion: async (item: Pedido) => {
        this.CargandoMenu = true;
        Utiles.GenerandoArchivo(true);
        await Envio.AbrirEtiqueta(item);
        this.CargandoMenu = false;
        Utiles.GenerandoArchivo(false);
      }
    },

    { Tipo: "titulo", Titulo: "Pedido" },
    {
      Tipo: "opcion",
      Titulo: "Editar pedido",
      Accion: async (item: Pedido) => {
        if (item.Tipo.esPlataforma) {
          router.push("/pedidos/plataformas/" + item.Id);
        } else {
          router.push("/pedidos/editar/" + item.Id);
        }
      }
    },

    {
      Tipo: "opcion",
      Titulo: "Cancelar pedido",
      Accion: async (item: Pedido) => {
        if (item.Tipo.esMercadoLibre) {
          Utiles.Notificaciones.Error(
            `No es posible cancelar pedidos de MercadoLibre.`
          );
        } else {
          if (
            await Utiles.Mensajes.SiNo(
              `Cancelar el pedido.`,
              `¿Está seguro de cancelar el pedido ${item.Id}?`
            )
          ) {
            let pdf = await item.saveEstado(Pedidos.Estados.Cancelado);
            if (pdf) {
              Utiles.Notificaciones.Info(`Pedido ${item.Id} cancelado.`);
            } else {
              Utiles.Notificaciones.Error(`Error al cancelar el pedido!`);
            }
          }
        }
      }
    },

    { Tipo: "titulo", Titulo: "Envíos" },
    {
      Tipo: "opcion",
      Titulo: "Treggo - Asignar a reparto",
      Accion: async (item: Pedido) => {
        if (!item.Tags.Pendiente) {
          await Utiles.Mensajes.Aceptar("Error", "El pedido ya fue procesado");
        } else if (item.Envio.Tipo.esMercadoEnvios) {
          await Utiles.Mensajes.Aceptar("Error", "El pedido es MercadoEnvios");
        } else {
          this.Controlador.Vista.BarraDerecha.Anchura.Espacio = 400;
          this.Controlador.Vista.BarraDerecha.Modo = "treggo";
          this.Controlador.Vista.BarraDerecha.Datos = { pedido: item.Id };
          this.Controlador.Vista.BarraDerecha.Abierto = true;
        }
      }
    },

    {
      Tipo: "opcion",
      Titulo: "Pickit - Crear envio",
      Accion: async (item: Pedido) => {
        if (!item.Tags.Pendiente) {
          await Utiles.Mensajes.Aceptar("Error", "El pedido ya fue procesado");
        } else if (item.Envio.Tipo.esMercadoEnvios) {
          await Utiles.Mensajes.Aceptar("Error", "El pedido es MercadoEnvios");
        } else {
          this.Controlador.Vista.BarraDerecha.Anchura.Espacio = 400;
          this.Controlador.Vista.BarraDerecha.Modo = "pickit";
          this.Controlador.Vista.BarraDerecha.Datos = { pedido: item.Id };
          this.Controlador.Vista.BarraDerecha.Abierto = true;
        }
      }
    },
    {
      Tipo: "opcion",
      Titulo: "Pickit - Cancelar envio",
      Accion: async (item: Pedido) => {
        if (!item.Envio.Tipo.esPickit) {
          await Utiles.Mensajes.Aceptar("Error", "El pedido no es Pickit");
        } else {
          if (
            await Utiles.Mensajes.SiNo(
              `Cancelar el pedido.`,
              `¿Está seguro de cancelar el envio?`
            )
          ) {
            if (await item.Envio.CancelarEnvioPickit()) {
              await Utiles.Notificaciones.Completado("Envio cancelado");
            } else {
              Utiles.Notificaciones.Error(`Error al cancelar el envio!`);
            }
          }
        }
      }
    }
  ];

  Abrir(item: Pedido) {
    this.Controlador.AbrirEnOtraPestaña(item);
  }

  AbrirEnOtraPestaña(item: Pedido) {
    this.Controlador.AbrirEnOtraPestaña(item);
  }
}
